import { KTCard } from "../../../../_metronic/helpers/components/KTCard";
import { KTCardBody } from "../../../../_metronic/helpers/components/KTCardBody";
import Box from "../../../../components/Box";
import CustomDateTimePicker from "../../../../components/CustomDateTimePicker";
import CustomSingleSelect, { CustomSingleSelectModel } from "../../../../components/CustomSingleSelect";
import CustomTextInput from "../../../../components/CustomTextInput";
import { GetYurticiCargoByIdResponseYurticiCargoMovement } from "../../../../models/response/yurticiCargo/GetYurticiCargoByIdResponse";
import { ConstantService } from "../../../../services/ConstantService";

interface Props {
    deliveryAndStatusRef: any
    selectedShippingStatus: CustomSingleSelectModel | undefined
    setSelectedShippingStatus: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    shippingCreateDate: string | undefined
    setShippingCreateDate: React.Dispatch<React.SetStateAction<string | undefined>>
    shippingLoadDate: string | undefined
    setShippingLoadDate: React.Dispatch<React.SetStateAction<string | undefined>>
    shippingDeliverDate: string | undefined
    setShippingDeliverDate: React.Dispatch<React.SetStateAction<string | undefined>>
    shippingDeliverer: string | undefined
    setShippingDeliverer: React.Dispatch<React.SetStateAction<string | undefined>>
    shippingReceiver: string | undefined
    setShippingReceiver: React.Dispatch<React.SetStateAction<string | undefined>>
    yurticiCargoMovements: GetYurticiCargoByIdResponseYurticiCargoMovement[]
}

const DeliveryAndStatus = ({
    deliveryAndStatusRef,
    selectedShippingStatus,
    setSelectedShippingStatus,
    setShippingCreateDate,
    shippingCreateDate,
    setShippingLoadDate,
    shippingLoadDate,
    setShippingDeliverDate,
    shippingDeliverDate,
    setShippingDeliverer,
    shippingDeliverer,
    setShippingReceiver,
    shippingReceiver,
    yurticiCargoMovements
}: Props) => {
    return (
        <div className='containerPart' ref={deliveryAndStatusRef} >
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Teslimat ve Durum</h4>

                    <div className="row">
                        <div className="col-md-4">
                            <CustomSingleSelect
                                labelText="Kargo Statüsü"
                                isLabelRequired
                                selectedValue={selectedShippingStatus}
                                onChange={setSelectedShippingStatus}
                                onMenuOpen={() => ConstantService.getConstantList('SHIPPING_STATUS_YURTICI')}
                                labelName='value'
                                valueName="constantId"
                                disabled
                            />
                        </div>

                        <div className="col-md-4">
                            <CustomDateTimePicker labelText="Oluşturma Tarihi" isLabelRequired value={shippingCreateDate} setValue={setShippingCreateDate} isDisabled />
                        </div>

                        <div className="col-md-4">
                            <CustomDateTimePicker labelText="Yükleme Tarihi" isLabelRequired value={shippingLoadDate} setValue={setShippingLoadDate} isDisabled />
                        </div>
                    </div>

                    <div className="row mt-5">
                        <div className="col-md-4">
                            <CustomDateTimePicker labelText="Teslim Tarihi" isLabelRequired value={shippingDeliverDate} setValue={setShippingDeliverDate} isDisabled />
                        </div>

                        <div className="col-md-4">
                            <CustomTextInput labelText="Teslim Eden" isLabelRequired value={shippingDeliverer} setValue={setShippingDeliverer} isDisabled />
                        </div>

                        <div className="col-md-4">
                            <CustomTextInput labelText="Teslim Alan" isLabelRequired value={shippingReceiver} setValue={setShippingReceiver} isDisabled />
                        </div>
                    </div>

                    <h4 className="mt-10 mb-10 text-black">Hareketler</h4>

                    <div className="row mt-5">
                        <div className="col-md-12">
                            <div className='table-responsive'>
                                <table id='kt_table_users' className='table align-middle table-row-dashed dataTable no-footer'>
                                    <thead>
                                        <tr className='text-start text-muted fw-bolder text-uppercase'>
                                            <th>Hareket</th>
                                            <th>Tarih</th>
                                        </tr>
                                    </thead>
                                    <tbody className='text-gray-600 fw-bold'>
                                        {
                                            yurticiCargoMovements.length == 0 && (
                                                <tr>
                                                    <td className="text-center" colSpan={99}>Kayıt bulunamadı.</td>
                                                </tr>
                                            )
                                        }
                                        {
                                            yurticiCargoMovements.map((item, index) =>
                                                <tr>
                                                    <td>{item.shippingStatusCode} - {item.shippingStatusName}</td>
                                                    <td>{item.shippingStatusDateStr}</td>
                                                </tr>
                                            )
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default DeliveryAndStatus;